// 0：未订购；10、已下单；11、订购中；12：订购成功；13：订购失败；14：退订中；15：退订成功
export const enum ORDER_STATE {
  NOT_ORDER = 0,
  PLACE_ORDER = 10,
  ORDERING = 11,
  ORDER_SUCCESS = 12,
  ORDER_FAIL = 13,
  CANCELING = 14,
  CANCEL_SUCCESS = 15,
}

// 1: 未订购 2：已订购
export const enum ORDERED_STATUS {
  NOT_ORDERED = 1,
  HAS_ORDERED = 2,
}

// 手机号激活状态 0=无需激活 1=未激活 2=已激活
export const enum MOBILE_ACTIVE_STATE {
  NO_NEED_ACTIVE = 0,
  NOT_ACTIVE = 1,
  ACTIVE = 2,
}

export const ORDER_GOODS_TYPE = {
  NORMAL: 1,
  OTHER: 2,
  BENEFIT: 3,
};
